export const THEME_NAME = {
  AUTO: 'auto',
  LIGHT: 'light',
  DARK: 'dark',
};

export const COLOR = {
  AI: '--color-ai',
  AI_BACKGROUND: '--color-ai-background',
  AI_TRANSLUCENT: '--color-ai-translucent',
  BACKGROUND_DARK: '--color-background-dark',
  BACKGROUND_DARK_TRANSLUCENT: '--color-background-dark-translucent',
  BACKGROUND_HOVER: '--color-background-hover',
  BACKGROUND_LIGHT: '--color-background-light',
  BACKGROUND_LIGHT_TRANSLUCENT: '--color-background-light-translucent',
  BORDER_ACTIVE: '--color-border-active',
  CLOVER: '--color-clover',
  CLOVER_ACTIVE: '--color-clover-active',
  CLOVER_HOVER: '--color-clover-hover',
  CLOVER_OVERLAY: '--color-clover-overlay',
  GRAY_01: '--color-gray-01',
  GRAY_02: '--color-gray-02',
  GRAY_03: '--color-gray-03',
  GRAY_04: '--color-gray-04',
  GRAY_05: '--color-gray-05',
  GRAY_07: '--color-gray-07',
  GRAY_10: '--color-gray-10',
  GRAY_20: '--color-gray-20',
  GRAY_30: '--color-gray-30',
  GRAY_40: '--color-gray-40',
  GRAY_50: '--color-gray-50',
  GRAY_60: '--color-gray-60',
  GRAY_70: '--color-gray-70',
  GRAY_80: '--color-gray-80',
  JADE: '--color-jade',
  JADE_TRANSLUCENT: '--color-jade-translucent',
  MINT: '--color-mint',
  MINT_ACTIVE: '--color-mint-active',
  MINT_BACKGROUND: '--color-mint-background',
  MINT_HOVER: '--color-mint-hover',
  MINT_TRANSLUCENT: '--color-mint-translucent',
  OVERLAY: '--color-overlay',
  PINE: '--color-pine',
  PINE_ACTIVE: '--color-pine-active',
  PINE_HOVER: '--color-pine-hover',
  ROUGE: '--color-rouge',
  ROUGE_ACTIVE: '--color-rouge-active',
  ROUGE_BACKGROUND: '--color-rouge-background',
  ROUGE_HOVER: '--color-rouge-hover',
  SHADOW: '--color-shadow',
  SHADOW_SOFT: '--color-shadow-soft',
  TEXT: '--color-text',
  TEXT_ACTIVE: '--color-text-active',
  TOOLTIP: '--color-tooltip',
};

export const CURSOR = {
  AUTO: 'auto',
  COPY: 'copy',
  CROSSHAIR: 'crosshair',
  DEFAULT: 'default',
  EW_RESIZE: 'ew-resize',
  GRAB: 'grab',
  GRABBING: 'grabbing',
  MOVE: 'move',
  NESW_RESIZE: 'nesw-resize',
  NONE: 'none',
  NOT_ALLOWED: 'not-allowed',
  NS_RESIZE: 'ns-resize',
  NWSE_RESIZE: 'nwse-resize',
  POINTER: 'pointer',
  TEXT: 'text',
};
